import React from "react";
import {useModal} from "../ModalContext";
import "./MediaHome.scss";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from '@fortawesome/free-solid-svg-icons';

function ModalHome() {
    const {closeModal} = useModal();

    return (
        <div className="fullscreen-modal">
            <div className={"modal-content"}>
                <div className={"close"} onClick={closeModal}><FontAwesomeIcon
                    icon={faXmark} color="#fafafa"/></div>

                <div className={"video-responsive"}>
                    <iframe
                        width="560"
                        height="315"
                        src="https://www.youtube.com/embed/9w2Itcb444Q"
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </div>
    );
}

export default ModalHome;